import { render, staticRenderFns } from "./SearchResultBlock.vue?vue&type=template&id=c61d4d58&scoped=true"
import script from "./SearchResultBlock.vue?vue&type=script&lang=js"
export * from "./SearchResultBlock.vue?vue&type=script&lang=js"
import style0 from "./SearchResultBlock.vue?vue&type=style&index=0&id=c61d4d58&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c61d4d58",
  null
  
)

export default component.exports